<template>
  <v-card class="my-1 fill-height d-flex flex-column" elevation="2">
    <v-card-title class="d-flex align-center">
      <h5>Escolher serviços</h5>
      <v-spacer />
      <div class="caption grey--text text--darken-1">
        {{ selectedCodigos.length }}/10 selecionados
      </div>
    </v-card-title>

    <v-card-text class="flex-grow-1 d-flex flex-column">
      <v-text-field
        v-model="busca"
        append-icon="mdi-magnify"
        label="Buscar por índice ou serviço..."
        single-line
        hide-details
        dense
        outlined
        class="mb-3"
      />

      <div
        v-if="loading"
        class="d-flex align-center justify-center flex-grow-1"
        style="min-height: 300px;"
      >
        <v-progress-circular indeterminate color="primary" size="32" />
      </div>

      <v-data-table
        v-else
        dense
        class="tabela-servicos-compacta flex-grow-1"
        :headers="headers"
        :items="tabelaServicosComIndex"
        :search="busca"
        :custom-filter="filtroPersonalizado"
        :options="{ itemsPerPage: -1 }"
        hide-default-footer
        disable-pagination
        fixed-header
        height="420"
        :header-props="{ sortByText: 'Ordenar Por' }"
        no-data-text="Nenhum registro disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :mobile-breakpoint="10"
        @click:row="toggleLinha"
        :item-class="rowClass"
        style="cursor: pointer;"
      >
        <template v-slot:item.selecionado="{ item }">
          <div
            class="d-flex align-center justify-center"
            style="width: 100%; height: 100%; cursor: pointer;"
          >
            <input
              type="checkbox"
              :checked="isSelecionado(item)"
              @click.stop="toggleLinha(item)"
            />
          </div>
        </template>

        <template v-slot:item.servico="{ item }">
          <div>
            <strong>{{ item.codigos_servico || "?" }}</strong>
            <v-tooltip v-if="Number(item.sa) <= 10" right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="warning" class="ml-1">
                  mdi-alert
                </v-icon>
              </template>
              <span>
                PSFP alto com volume baixo (SA ≤ 10) — possível efeito
                denominador.
              </span>
            </v-tooltip>
          </div>
          <div style="font-size: 12px; color: #888;">
            {{ item.nome_por_indice || item.descricao_por_indice }}
          </div>
        </template>

        <template v-slot:item.psfp="{ item }">
          <span
            v-if="item.psfp !== null && item.psfp !== undefined"
            :style="{ color: corFaixa(item.faixa_chave), fontWeight: 'bold' }"
          >
            {{ item.psfp | parseNumberToFloatBrIgnoringNaN }}%
          </span>
          <span
            v-else
            :style="{ color: corFaixa(item.faixa_chave), fontWeight: 'bold' }"
          >
            —
          </span>
        </template>

        <template v-slot:item.sa="{ item }">
          {{ item.sa | parseNumberToFloatBrIgnoringNaN }}
        </template>

        <template v-slot:item.sfp="{ item }">
          {{ item.sfp | parseNumberToFloatBrIgnoringNaN }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "DashboardIsfpPsfpTabelaSimulador",
    props: {
      tabelaServicos: { type: Array, default: () => [] },
      selectedCodigos: { type: Array, default: () => [] },
      loading: { type: Boolean, default: false },
    },
    data: () => ({
      busca: "",
    }),
    computed: {
      headers() {
        return [
          { text: "", value: "selecionado", width: "45px", sortable: false },
          {
            text: "Índice",
            value: "indice_categoria",
            align: "center",
            width: "80px",
          },
          { text: "Serviço", value: "servico", sortable: false },
          { text: "Sa", value: "sa", align: "center", width: "72px" },
          { text: "SFP", value: "sfp", align: "center", width: "72px" },
          { text: "PSFP", value: "psfp", align: "center", width: "88px" },
        ];
      },
      tabelaServicosComIndex() {
        return this.tabelaServicos.map((item, i) => ({
          ...item,
          index: i + 1,
        }));
      },
    },
    methods: {
      getCodigoPrincipal(item) {
        return item?.codigos_servico
          ? parseInt(
              String(item.codigos_servico)
                .split(",")[0]
                .trim(),
            )
          : null;
      },

      isSelecionado(item) {
        return this.selectedCodigos.includes(item?.indice_categoria);
      },

      toggleLinha(item) {
        this.$emit("toggleServico", item);
      },

      filtroPersonalizado(value, search, item) {
        if (!search) return true;

        const termo = String(search).toLowerCase();

        const codigos = String(item.codigos_servico ?? "").toLowerCase();
        const nome = String(
          item.nome_por_indice ?? item.descricao_por_indice ?? "",
        ).toLowerCase();
        const indice = String(item.indice_categoria ?? "").toLowerCase();

        return (
          codigos.includes(termo) ||
          nome.includes(termo) ||
          indice.includes(termo)
        );
      },

      rowClass(item) {
        return this.isSelecionado(item)
          ? "row-selecionada primary lighten-5"
          : "";
      },

      corFaixa(faixaChave) {
        const cores = {
          ate_1: "#4CAF50",
          de_1_a_5: "#8BC34A",
          de_5_a_10: "#FFC107",
          de_10_a_20: "#FF9800",
          acima_20: "#F44336",
        };
        return cores[faixaChave] ?? "#000";
      },
    },
  };
</script>

<style scoped>
  .tabela-servicos-compacta ::v-deep td {
    font-size: 12px !important;
  }

  .tabela-servicos-compacta ::v-deep th {
    font-size: 12px !important;
  }

  .tabela-servicos-compacta ::v-deep td,
  .tabela-servicos-compacta ::v-deep th {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .tabela-servicos-compacta ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
  }
</style>
